import { render, staticRenderFns } from "./pageError.vue?vue&type=template&id=28e8a006&scoped=true&lang=pug"
import script from "./pageError.vue?vue&type=script&lang=js"
export * from "./pageError.vue?vue&type=script&lang=js"
import style0 from "./pageError.vue?vue&type=style&index=0&id=28e8a006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8a006",
  null
  
)

export default component.exports